import { defineStore } from 'pinia';

export const localeStore = defineStore('locale', {
    state: () => {
        return {
            lang: "es"
        }
    }
});